import SearchGeneric from "./SearchGeneric";

export default SearchGeneric;
